import { useNavigate } from 'react-router-dom';
import { IOtherNews } from '../../../common/tin-gpt/define-news'
import ImageNotFound from '../../../images/homepage/Image_not_available.png';
import './styles.otherNews.scss'
import { useEffect, useState } from 'react';
interface Props {
    otherNewsLst: any
}

const OtherNews = (props: Props) => {

    const [imageOtherNews, setImageOtherNews] = useState<any>();

    useEffect(() => {
        console.log('otherNewsLst', props.otherNewsLst);

        for (let i = 0; i < props.otherNewsLst?.articles?.length; i++) {
            if (props.otherNewsLst?.articles[i]?.imageContents && props.otherNewsLst?.articles[i]?.imageContents.length > 0) {
                setImageOtherNews(props.otherNewsLst?.articles[i]?.imageContents[0]);
                // Sau khi đã gán giá trị thì break
                break;
            }
        }
    }, [props.otherNewsLst])

    const navigate = useNavigate();
    // Hàm thực hiện thay thế ảnh khi ảnh bị lỗi
    const handleImageError = (e: any) => {
        e.target.onerror = null;
        e.target.src = ImageNotFound;
    }
    return (
        <div className='other-news-main'>
            <div className='other-news-title'
                onClick={() => {
                    localStorage.setItem('category', JSON.stringify(props.otherNewsLst.category));
                    const name = props.otherNewsLst.category.name.replace(/ /g, '-').toLowerCase();

                    navigate(`/category/${name}`);
                }}
            >
                {props.otherNewsLst?.category?.name}
            </div>
            <div className='other-news-content'>
                <div className='other-news-item-image'>
                    <img src={imageOtherNews ? imageOtherNews : ImageNotFound}
                        alt=""
                        onError={handleImageError} />
                </div>
                <div className='other-news-item-lst'>
                    {(props.otherNewsLst?.articles && props.otherNewsLst?.articles.length > 0) && props.otherNewsLst?.articles.map((item: any, index: any) => (
                        <>
                            {item.title ?
                                <div className='other-news-item-title'
                                    onClick={() => {
                                        const url = new URL(item.link);
                                        const text = url.hostname + url.pathname;
                                        const id = item.id
                                        console.log(text);
                                        // const tmp = props.newsContent.title.replace(/[/,:?-]/g, '');
                                        // const title = tmp.replace(/ /g, '-').toLowerCase();
                                        if (item.type === 'AI'|| text.includes('watch')) {
                                            navigate(`/detail-news/id=${id}`,);
                                        }
                                        else {
                                            navigate(`/detail-news/${text}`);
                                        }

                                        // Gán giá trị id vào localStorage
                                        localStorage.setItem('id', item.id);
                                        localStorage.setItem('link', item.link);
                                    }}
                                >
                                    {item.title}
                                </div>
                                :
                                <div className='other-news-item-title'
                                    onClick={() => {
                                        const url = new URL(item.link);
                                        const text = url.hostname + url.pathname;
                                        const id = item.id
                                        console.log(text);
                                        // const tmp = props.newsContent.title.replace(/[/,:?-]/g, '');
                                        // const title = tmp.replace(/ /g, '-').toLowerCase();

                                        if (item.type === 'AI'|| text.includes('watch')) {
                                            navigate(`/detail-news/id=${id}`,);
                                        }
                                        else {
                                            navigate(`/detail-news/${text}`);
                                        }

                                        // Gán giá trị id vào localStorage
                                        localStorage.setItem('id', item.id);
                                        localStorage.setItem('link', item.link);
                                    }}
                                >
                                    {item.textContent}
                                </div>
                            }

                        </>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default OtherNews
